var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('AkvelonLogoImage',{staticClass:"ml-5 akvelon-logo__image"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }